jQuery(document).ready(function ($) {
    const RESULTS = '.pricing-calculator__results';

    // Expand / collapse a service on the estimate to reveal the answers behind its price.
    $.fn.toggleServiceDetail = function () {
        const $row = this.closest('.pricing-calculator__estimate-row');
        const $detail = $row.find('.pricing-calculator__estimate-detail');
        const open = !$row.hasClass('is-open');

        $row.toggleClass('is-open', open);
        this.attr('aria-expanded', open ? 'true' : 'false');

        $detail.stop(true, true).slideToggle(250);

        return this;
    }

    $.fn.getAnswersToEdit = function () {
        const $item = this.closest('.pricing-calculator__qa');

        if ($item.next('.pricing-calculator__change').length > 0) {
            $item.next('.pricing-calculator__change').remove();
            return;
        }

        const question = this.attr('data-question-id');

        const _this = this;

        dataLayer.push({
            event: 'editing_answer'
        });

        $.ajax({
            url: arise_pc.ajax_url,
            type: 'POST',
            data: {
                question: question,

                action: 'arise_pc_edit_answer',
                nonce: arise_pc.nonce
            },

            beforeSend: function () {
                _this.closest(RESULTS).addClass('loading');
            },

            success: function (response) {
                _this.closest(RESULTS).removeClass('loading');

                const $panel = $(response.data.answers);
                $panel.insertAfter($item);

                if (response.data.current_selection !== null && response.data.current_selection !== '') {
                    const selectedIndices = String(response.data.current_selection).split(',').map(Number);
                    $panel.find('.pricing-calculator__answer').each(function (i) {
                        if (selectedIndices.includes(i)) {
                            $(this).addClass('selected').attr('aria-checked', 'true');
                        }
                    });
                }

                $panel.find('.pricing-calculator__change--container').append(
                    $('<button class="pc-confirm-edit" type="button"></button>').text((arise_pc.labels && arise_pc.labels.confirm_selection) || 'Confirm selection')
                );
            },

            complete: function () {
                _this.closest(RESULTS).removeClass('loading');
            }
        });
    }

    $.fn.submitSelectedAnswers = function () {
        const $change = this.closest('.pricing-calculator__change');
        const question = $change.prev().find('.pc-edit').attr('data-question-id');
        const selectedIndices = [];

        $change.find('.pricing-calculator__answer.selected').each(function () {
            selectedIndices.push($(this).index());
        });

        if (selectedIndices.length === 0) return;

        const response = question + ':' + selectedIndices.join(',');

        const _this = this;
        const $results = this.closest(RESULTS);

        // Remember which services were expanded so the refreshed estimate opens in the same place.
        const openServices = $results.find('.pricing-calculator__estimate-row.is-open').map(function () {
            return $(this).attr('data-service');
        }).get();

        dataLayer.push({
            event: 'submitting_changed_answer',
            answer_name: $change.find('.pricing-calculator__answer.selected').map(function () {
                return $(this).attr('title');
            }).get().join(', ')
        });

        $.ajax({
            url: arise_pc.ajax_url,
            type: 'POST',
            data: {
                response: response,

                action: 'arise_pc_submit_new_answer',
                nonce: arise_pc.nonce
            },

            beforeSend: function () {
                $results.addClass('loading');
            },

            success: function (response) {
                $results.removeClass('loading');

                const $new = $(response.data.results);
                $new.insertAfter($results).show();
                $results.remove();

                openServices.forEach(function (slug) {
                    $new.find('.pricing-calculator__estimate-row[data-service="' + slug + '"] .pc-toggle-service').trigger('click');
                });
            },

            complete: function () {
                $results.removeClass('loading');
            }
        });
    }

    $(document).on('click', '.pc-toggle-service', function (event) {
        event.preventDefault();

        $(this).toggleServiceDetail();
    });

    $(document).on('click', '.pc-edit', function (event) {
        event.preventDefault();

        $(this).getAnswersToEdit();
    });

    $(document).on('click', '.pricing-calculator__change .pc-confirm-edit', function (event) {
        $(this).submitSelectedAnswers();
    });
});
